/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JpCoBenefitoneBsdpBffDtoBffBoCodePostRequest
 */
export interface JpCoBenefitoneBsdpBffDtoBffBoCodePostRequest {
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffDtoBffBoCodePostRequest
     */
    customerNo?: string;
}

export function JpCoBenefitoneBsdpBffDtoBffBoCodePostRequestFromJSON(json: any): JpCoBenefitoneBsdpBffDtoBffBoCodePostRequest {
    return JpCoBenefitoneBsdpBffDtoBffBoCodePostRequestFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsdpBffDtoBffBoCodePostRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsdpBffDtoBffBoCodePostRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'customerNo': !exists(json, 'customerNo') ? undefined : json['customerNo'],
    };
}

export function JpCoBenefitoneBsdpBffDtoBffBoCodePostRequestToJSON(value?: JpCoBenefitoneBsdpBffDtoBffBoCodePostRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'customerNo': value.customerNo,
    };
}

